import { render, staticRenderFns } from "./AdminStatsNav.vue?vue&type=template&id=418d478d&"
import script from "./AdminStatsNav.vue?vue&type=script&lang=js&"
export * from "./AdminStatsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports